import React from "react";
import { PageLayout } from "@icoach/components";
import { Grid } from "@mui/material";
import MemberAcquisitionSourceChart from "@icoach/dashboard/MemberAcquisitionSourceChart";
import MemberAgeDistribution from "@icoach/dashboard/MemberAgeDistribution";
import MemberAgeInClub from "@icoach/dashboard/MemberAgeInClub";
import MembershipExpireTime from "@icoach/dashboard/MembershipExpireTime";
import MemberCheckInHeatmap from "@icoach/dashboard/MemberCheckInHeatmap";
import TotalWorkoutCountDistribution from "@icoach/dashboard/TotalWorkoutCountDistribution";
import WorkoutFrequencyLevel from "@icoach/dashboard/WorkoutFrequencyLevel";
import CycleProteinOrders from "@icoach/dashboard/CycleProteinOrders";
import CycleProbioticsOrders from "@icoach/dashboard/CycleProbioticsOrders";
import CycleCalciumOrders from "@icoach/dashboard/CycleCalciumOrders";
import YearlyAverageSpend from "@icoach/dashboard/YearlyAverageSpend";
import YearlyPurchaseCount from "@icoach/dashboard/YearlyPurchaseCount";
import YearlyTotalSpend from "@icoach/dashboard/YearlyTotalSpend";
import NewMemberSource from "@icoach/dashboard/NewMemberSource";
import NewMemberAgeDistribution from "@icoach/dashboard/NewMemberAgeDistribution";
import NewWorkoutFrequencyPrediction from "@icoach/dashboard/NewWorkoutFrequencyPrediction";
import NewMemberProteinOrders from "@icoach/dashboard/NewMemberProteinOrders";
import NewMemberProbioticsOrders from "@icoach/dashboard/NewMemberProbioticsOrders";
import NewMemberCalciumOrders from "@icoach/dashboard/NewMemberCalciumOrders";
import PausedMemberAge from "@icoach/dashboard/PausedMemberAge";
import PauseReasons from "@icoach/dashboard/PauseReasons";
import QuitMemberAgeDistribution from "@icoach/dashboard/QuitMemberAgeDistribution";
import QuitMemberTenure from "@icoach/dashboard/QuitMemberTenure";
import QuitReasons from "@icoach/dashboard/QuitReasons";
import MetricSummaryCard from "@icoach/dashboard/MetricSummaryCard";
import * as echarts from "echarts/core";
import { Box } from "@curves/ui-base";

import { BarChart, PieChart, HeatmapChart } from "echarts/charts";
import { GridComponent, TooltipComponent, LegendComponent, TitleComponent, DatasetComponent, GraphicComponent, VisualMapComponent } from "echarts/components";
import { CanvasRenderer } from "echarts/renderers";

echarts.use([BarChart, PieChart, HeatmapChart, DatasetComponent, GridComponent, TitleComponent, TooltipComponent, LegendComponent, CanvasRenderer, GraphicComponent, VisualMapComponent]);

// dashboardChartHeight.js
export const DASHBOARD_CHART_HEIGHT = {
	S: 220, // Compact
	M: 340, // Standard
	L: 440, // Tall
};

const DashboardPage = props => {
	return (
		<PageLayout>
			<PageLayout.Header title="會員輪廓頁" />
			<Grid container columns={10} spacing={1}>
				<Grid item xs={10} sm={5} md={5} lg={2}>
					<MetricSummaryCard />
				</Grid>
				<Grid item xs={10} sm={5} md={5} lg={2}>
					<MetricSummaryCard />
				</Grid>
				<Grid item xs={10} sm={5} md={5} lg={2}>
					<MetricSummaryCard />
				</Grid>
				<Grid item xs={10} sm={5} md={5} lg={2}>
					<MetricSummaryCard />
				</Grid>
				<Grid item xs={10} sm={5} md={5} lg={2}>
					<MetricSummaryCard />
				</Grid>
			</Grid>
			<Box className="mt-2"></Box>
			<Grid container spacing={1}>
				<Grid height={DASHBOARD_CHART_HEIGHT.L} item xs={12} md={6}>
					{/* 會員管道來源 */}
					<MemberAcquisitionSourceChart />
				</Grid>
				<Grid height={DASHBOARD_CHART_HEIGHT.L} item xs={12} md={6}>
					{/* 會員年齡分佈 */}
					<MemberAgeDistribution />
				</Grid>
				<Grid height={DASHBOARD_CHART_HEIGHT.L} item xs={12} md={6}>
					{/* 會員年資 */}
					<MemberAgeInClub />
				</Grid>
				<Grid height={DASHBOARD_CHART_HEIGHT.L} item xs={12} md={6}>
					{/* 會籍到期時間 */}
					<MembershipExpireTime />
				</Grid>
				<Grid height={DASHBOARD_CHART_HEIGHT.L} item xs={12} md={6}>
					{/* 運動頻率分級 */}
					<WorkoutFrequencyLevel />
				</Grid>
				<Grid height={DASHBOARD_CHART_HEIGHT.L} item xs={12} md={6}>
					{/* 累計運動次數分布 */}
					<TotalWorkoutCountDistribution />
				</Grid>
				<Grid height={DASHBOARD_CHART_HEIGHT.M} item xs={12}>
					{/* 入場時間分佈熱點 */}
					<MemberCheckInHeatmap />
				</Grid>
				<Grid height={DASHBOARD_CHART_HEIGHT.M} item xs={12} md={4}>
					{/* 循環蛋白訂購狀況 */}
					<CycleProteinOrders />
				</Grid>
				<Grid height={DASHBOARD_CHART_HEIGHT.M} item xs={12} md={4}>
					{/* 循環益生菌訂購狀況 */}
					<CycleProbioticsOrders />
				</Grid>
				<Grid height={DASHBOARD_CHART_HEIGHT.M} item xs={12} md={4}>
					{/* 循環鈣力嗨訂購狀況 */}
					<CycleCalciumOrders />
				</Grid>
				{/* 年度平均客單價 */}
				<Grid height={DASHBOARD_CHART_HEIGHT.M} item xs={12} md={4}>
					<YearlyAverageSpend />
				</Grid>
				{/* 年度消費次數 */}
				<Grid height={DASHBOARD_CHART_HEIGHT.M} item xs={12} md={4}>
					<YearlyPurchaseCount />
				</Grid>
				{/* 年度消費金額 */}
				<Grid height={DASHBOARD_CHART_HEIGHT.M} item xs={12} md={4}>
					<YearlyTotalSpend />
				</Grid>
				{/* 新會員來源 */}
				<Grid height={DASHBOARD_CHART_HEIGHT.M} item xs={12} md={4}>
					<NewMemberSource />
				</Grid>
				{/* 新會員年齡分佈 */}
				<Grid height={DASHBOARD_CHART_HEIGHT.M} item xs={12} md={4}>
					<NewMemberAgeDistribution />
				</Grid>
				{/* 運動頻率預測 */}
				<Grid height={DASHBOARD_CHART_HEIGHT.M} item xs={12} md={4}>
					<NewWorkoutFrequencyPrediction />
				</Grid>
				{/* 新會員蛋白訂購狀況 */}
				<Grid height={DASHBOARD_CHART_HEIGHT.M} item xs={12} md={4}>
					<NewMemberProteinOrders />
				</Grid>
				{/* 新會員益生菌訂購狀況 */}
				<Grid height={DASHBOARD_CHART_HEIGHT.M} item xs={12} md={4}>
					<NewMemberProbioticsOrders />
				</Grid>
				{/* 新會員鈣力嗨訂購狀況 */}
				<Grid height={DASHBOARD_CHART_HEIGHT.M} item xs={12} md={4}>
					<NewMemberCalciumOrders />
				</Grid>
				{/* 暫停會員年齡層分布 */}
				<Grid height={DASHBOARD_CHART_HEIGHT.M} item xs={12} md={6}>
					<PausedMemberAge />
				</Grid>
				{/* 主要暫停原因統計 */}
				<Grid height={DASHBOARD_CHART_HEIGHT.M} item xs={12} md={6}>
					<PauseReasons />
				</Grid>
				{/* 退會年齡層占比 */}
				<Grid height={DASHBOARD_CHART_HEIGHT.M} item xs={12} md={6}>
					<QuitMemberAgeDistribution />
				</Grid>
				{/* 退會會員年資分布 */}
				<Grid height={DASHBOARD_CHART_HEIGHT.M} item xs={12} md={6}>
					<QuitMemberTenure />
				</Grid>
				{/* 主要退會原因分析 */}
				<Grid height={DASHBOARD_CHART_HEIGHT.M} item xs={12} md={6}>
					<QuitReasons />
				</Grid>
			</Grid>
		</PageLayout>
	);
};

export default DashboardPage;
